export default __webpack_public_path__ + "static/home-astronaut-5385d8b501906e8f47b0e36dbce8efcb.png";